<template>
  <highliter
    v-model="section.name"
    section-type="element"
    class="highlight-element !z-[1001]"
    :uid="section.uid"
    :dublicate-deep="parentUID"
    :dublicate="section"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @dublicate="$emit('dublicate')"
    @delete="$emit('delete')"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings('video')"
  >
    <div class="p-1 -m-1">
      <video-play-v2
        :class="{'element-hidden': !visability('video')}"
        :customs="section.options.content.video"
        :section="section"
      />
    </div>
  </highliter>
</template>

<script>
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'

export default {
  name: 'FeaturedItems1',

  components: {Highliter},

  mixins: [SectionMixin]
}
</script>
